<template>
  <v-tooltip class="v-tooltip-custom-help" top max-width="300" data-cy="tooltip">
    <template v-slot:activator="{ on }">
      <v-icon v-bind="$attrs" class="v-tooltip-custom-help-icon" :color="color" :class="iclass" v-on="on" small data-cy="tooltip-icon">{{ icon }}</v-icon>
    </template>
    <span style="word-wrap: break-word;" class="v-tooltip-custom-help-text" data-cy="tooltip-text">{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    iclass: { type: String, default: 'mt-1' },
    color: { type: String, default: 'primary' },
    icon: { type: String, default: 'fas fa-question-circle' },
    text: { type: String, default: '' }
  }
}
</script>

<style>
.v-tooltip-custom-help,.v-tooltip-custom-help-icon {
    pointer-events: auto !important;
}
</style>
